module.exports = "fonts/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-muw.woff2";